import { render, staticRenderFns } from "./VenusIndex.vue?vue&type=template&id=2da93e61&scoped=true"
import script from "./VenusIndex.vue?vue&type=script&lang=js"
export * from "./VenusIndex.vue?vue&type=script&lang=js"
import style0 from "./VenusIndex.vue?vue&type=style&index=0&id=2da93e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da93e61",
  null
  
)

export default component.exports